import { render, staticRenderFns } from "./TransferComponent.vue?vue&type=template&id=81145320&scoped=true&"
import script from "./TransferComponent.vue?vue&type=script&lang=ts&"
export * from "./TransferComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81145320",
  null
  
)

export default component.exports